import * as yup from "yup";

const phoneRegex = /^(010|011|012|015)\d{8}$/;

export const validationSchemaEn = yup.object({
  name: yup
    .string()
    .min(3, "Name must be at least 3 characters")
    .required("Name is required"),
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
  // avatar: yup.string(),
  refContact: yup.object({
    name: yup.string().nullable(),

    //   .required("Contact name is required"),

    phone: yup
      .string()

      .matches(
        phoneRegex,
        "Invalid phone number. Must be 11 digits and start with 010, 011, 012, or 015"
      )
      .nullable(),

    //   .required("Contact phone is required"),
  }),
  secondPhone: yup
    .string()
    .matches(
      phoneRegex,
      "Invalid phone number. Must be 11 digits and start with 010, 011, 012, or 015"
    )
    .nullable(),
  phone: yup
    .string()
    .matches(
      phoneRegex,
      "Invalid phone number. Must be 11 digits and start with 010, 011, 012, or 015"
    )
    .nullable(),
  // nationalId: yup.string().required("National ID is required"),
});
